import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79b235f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Buscar")
const _hoisted_2 = {
  key: 0,
  class: "logo"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/img/WEAS_LOGO.png",
  alt: "WEAS_LOGO"
}, null, -1))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "list-images" }

import { onMounted, ref, watch } from "vue";
import { getSamplingPointImages } from "@/service/image.service";
import StationImageComponent from "@/components/stations/StationImage.component.vue";
import ObserverComponent from "@/components/Observer.component.vue";
import { SamplingPoint } from "@/types/samplingpoint.type";
import {
  getSamplingPointById,
  getSamplingPointsNoRelations,
  getSamPointOnlyParameters,
} from "@/service/samplingpoint.service";
import { Image } from "@/types/Image.type";
import ElMessage from "element-plus/lib/components/message";
import { getDatesWithEstimations } from "@/service/estimation.service";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const images = ref<Image[]>([]);
const hasMore = ref(true);
const fromDate = ref<string>("");
const toDate = ref<string>("");
const currentPage = ref<number>(1);
const totalRows = ref<number>(1);
const samplingPoint = ref<string>("");
const isSearching = ref<boolean>(false);
const rowPerPage = ref<number>(10);
const samplingPoints = ref<SamplingPoint[]>([]);
const datesWithEstimations = ref<string[]>([]);

onMounted(async () => {
  samplingPoints.value = (await getSamplingPointsNoRelations())?.data || [];
});

const searchImages = async () => {
  if (fromDate.value && toDate.value && samplingPoint) {
    try {
      const samplingPointData = await getSamplingPointById(Number(samplingPoint.value));
      if (samplingPointData) {
        const data = await getSamplingPointImages(
          samplingPoint.value,
          1,
          rowPerPage.value,
          fromDate.value,
          toDate.value
        );

        if (!data.data) {
          ElMessage.warning("No hay imágenes en el período.");
          return;
        }
        images.value = data.data;
        totalRows.value = data.totalRows;
        currentPage.value = data.currentPage;
        hasMore.value = data.totalRows > 1;
        isSearching.value = true;
      } else {
        console.error("Sampling point not found");
      }
    } catch (error) {
      console.error("Error fetching sampling point:", error);
    }
  } else {
    ElMessage.warning("Completa el formulario primero");
  }
};

const showMore = async () => {
  if (!isSearching.value || !hasMore.value) {
    ElMessage.warning("No hay más imágenes en el período.");
    return;
  }

  if (!samplingPoint.value) {
    ElMessage.warning("Selecciona un punto de monitorización.");
    return;
  }

  try {
    const data = await getSamplingPointImages(
      samplingPoint.value,
      currentPage.value + 1,
      rowPerPage.value,
      fromDate.value,
      toDate.value
    );

    if (Array.isArray(data.data) && data.data.length > 0) {
      images.value = [...images.value, ...data.data];
      currentPage.value += 1;
    } else {
      hasMore.value = false;
      ElMessage.warning("No hay más imágenes en el período.");
    }
  } catch (error) {
    console.error("Error cargando más imágenes:", error);
    ElMessage.error("Hubo un error al cargar más imágenes.");
  }
};

const getMarkedDates = async () => {
  const samplingPointParams = await getSamPointOnlyParameters(Number(samplingPoint.value));
  const paramsList = samplingPointParams.map((item) => item.id ?? 0);
  console.log("samplingPointParams", paramsList);
  if (paramsList !== undefined) {
    await getDatesWithEstimations([Number(samplingPoint)], paramsList)
      .then((response) => {
        datesWithEstimations.value = response.map((date) =>
          new Date(date.image_date).toDateString()
        );
        console.log("datesWithEstimations.value", datesWithEstimations.value);
      })
      .catch((error) => console.error(error));
  }
};

watch(samplingPoint, async () => {
  getMarkedDates();
});

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_center = _resolveComponent("center")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_card, {
      class: "header-import page-title",
      style: {"margin-bottom":"5px"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("text.galleryService")), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { gutter: 10 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { lg: 5 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, {
              class: "app-main-full-height-lg-and-up",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 24,
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("label.samplingPoint")), 1),
                    _createVNode(_component_el_form_item, {
                      prop: "samplingPointIds",
                      class: "full-width-item"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: samplingPoint.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((samplingPoint).value = $event)),
                          filterable: "",
                          style: {"width":"100%"},
                          placeholder: "Punto"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(samplingPoints.value, (option) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: option.id,
                                label: option.name,
                                value: option.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 24,
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("label.periodStartDate")), 1),
                    _createVNode(_component_el_form_item, { class: "full-width-item" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: fromDate.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fromDate).value = $event)),
                          type: "datetime",
                          placeholder: "Desde",
                          class: "custom-date-picker",
                          style: {"width":"100%"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 24,
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("label.periodEndDate")), 1),
                    _createVNode(_component_el_form_item, { class: "full-width-item" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: toDate.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((toDate).value = $event)),
                          type: "datetime",
                          placeholder: "Hasta",
                          class: "custom-date-picker",
                          style: {"width":"100%"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: searchImages,
                  style: {"margin-top":"10px","width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { lg: 19 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, {
              class: "app-main-full-height-lg-and-up",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                (!isSearching.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createVNode(_component_center, null, {
                        default: _withCtx(() => [
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t("message.gallery")), 1)
                        ]),
                        _: 1
                      }),
                      _hoisted_3
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(StationImageComponent, { images: images.value }, null, 8, ["images"]),
                        (hasMore.value)
                          ? (_openBlock(), _createBlock(ObserverComponent, {
                              key: 0,
                              onIntersect: showMore
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ]))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})